module.exports = __webpack_public_path__ + "img/logo.ad6b116a.png";